import script from "./sensitive-file-scanning.vue?vue&type=script&setup=true&lang=ts"
export * from "./sensitive-file-scanning.vue?vue&type=script&setup=true&lang=ts"

import "./sensitive-file-scanning.vue?vue&type=style&index=0&id=66c38997&lang=scss&scoped=true"
import "./sensitive-file-scanning.vue?vue&type=style&index=1&id=66c38997&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66c38997"]])

export default __exports__